(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/vi_VN/all.js#xfbml=1";
  js.async = true;
  js.defer = true;
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
